@if (vaultNav(); as nav) {
  @if (nav.vaults.length > 1) {
    <bit-nav-item [text]="'allItems' | i18n" (mainContentClicked)="selectAllItems()">
      <bit-icon-tile icon="bwi-list" variant="brand" emphasis="bold" size="sm" />
    </bit-nav-item>
  }

  <ng-template #vaultGroups>
    @for (vault of nav.vaults; track vault.id) {
      <bit-nav-group [text]="vault.label" [open]="nav.organizationDataOwnership">
        <bit-icon-tile [icon]="vault.icon" [color]="vaultTileColor(vault)" size="sm" />
        <bit-nav-item
          icon="bwi-list-alt"
          [text]="'allVaultItems' | i18n"
          (mainContentClicked)="selectVault(vault)"
        ></bit-nav-item>
      </bit-nav-group>
    }
  </ng-template>

  @if (nav.vaults.length === 1 && !nav.organizationDataOwnership) {
    @let loneVault = nav.vaults[0];
    <bit-nav-item [text]="loneVault.label" (mainContentClicked)="selectVault(loneVault)">
      <bit-icon-tile [icon]="loneVault.icon" [color]="vaultTileColor(loneVault)" size="sm" />
    </bit-nav-item>
  } @else if (nav.organizationDataOwnership) {
    <ng-container [ngTemplateOutlet]="vaultGroups"></ng-container>
  } @else if (nav.vaults.length > 1) {
    <bit-nav-section [label]="'vaults' | i18n">
      <ng-container [ngTemplateOutlet]="vaultGroups"></ng-container>
    </bit-nav-section>
  }
}
